import urls from "../../../../../../../../global/constants/UrlConstants";
import { getCallParams, makeCall } from "../../../../../../../../utils/service";

export async function getAllDepartment() {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(urls.GETALLDEPARTMENT, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function addDepartment(newDepartment: any) {
  const body = { department_name: newDepartment.department_name };
  try {
    const callParams = await getCallParams("POST", body);
    const response = await makeCall(urls.ADDDEPARTMENT, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function deleteDepartment(departmentId: string) {
  try {
    const callParams = await getCallParams("DELETE");
    const response = await makeCall(
      urls.DELETEDEPARTMENTBYID + departmentId,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}
